import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { ApiGetDataSetFiltersServiceResponse } from "./getDataSetFilters.service";

export const getDataSetFiltersEndpoint = (forceReload: boolean): AxiosPromise<ApiGetDataSetFiltersServiceResponse> =>
    apiWrapper.instance!.get(`rest/sdo/dataSetFilters?forceReload=${forceReload}`);
